export function getVideoPlaylistIsLoaded(state) {
    return state.videoPlaylist.isLoaded;
}

export function getVideoPlaylistUrl(state) {
    return state.videoPlaylist.url;
}

export function getVideoPlaylistId(state) {
    return state.videoPlaylist.id;
}

export function hasUploadedVideo(state) {
    return state.hasUploadedVideo
}

export function hasVideoPlaylists(state) {
    return state.hasVideoPlaylists
}

export function getVideoPlaylistName(state) {
    return state.videoPlaylist.name || `Playlist ${getVideoPlaylistCreatedAt(state)}`;
}

export function getVideoPlaylistPublishedAt(state) {
    if (!state.videoPlaylist.publishedAt) return '';
    return new Date(state.videoPlaylist.publishedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

export function getVideoPlaylistCreatedAt(state) {
    if (!state.videoPlaylist.createdAt) return '';
    const date = new Date(state.videoPlaylist.createdAt);
    const formattedDate = new Intl.DateTimeFormat('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    }).format(date);
    const formattedTime = new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }).format(date);
    return `${formattedDate} ${formattedTime}`;
}